import { render, staticRenderFns } from "./ReactionList.vue?vue&type=template&id=59895031&"
import script from "./ReactionList.vue?vue&type=script&lang=js&"
export * from "./ReactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports